<div class="layout-wrapper flex flex-column min-h-screen">
  <!-- Header -->
  <header role="banner">
    <nav aria-label="Navegación principal">
      <p-menubar [model]="menuItems" startTemplate>
        <a routerLink="/" class="flex align-items-center no-underline">
          <img
            src="assets/images/logo-chatrandom.svg"
            alt="Logo Chats Random"
            height="48"
            class="logo-mode"
          />
          <h1 class="text-xl font-bold text-primary ml-2">Chats Random!</h1>
        </a>
      </p-menubar>
    </nav>
    <!-- Subtítulo para SEO y accesibilidad -->
    <h2 class="sr-only">
      Charla con personas al azar en segundos: gratis, anónimo y sin likes
    </h2>
  </header>

  <!-- Main content -->
  <main role="main" class="flex-grow-1">
    <router-outlet></router-outlet>
  </main>

  <!-- Footer -->
  <footer role="contentinfo" class="surface-50 p-4">
    <div class="container mx-auto flex flex-column">
      <!-- Fila 1: Nombre y copyright -->
      <div class="flex align-items-center">
        <a
          routerLink="/"
          class="font-bold text-lg text-primary"
          aria-label="Volver al inicio"
        >
          Chats Random!
        </a>
        <small class="text-secondary ml-2">© 2025 Chats Random!s, Inc. V:0.0.5</small>
      </div>
      <!-- Fila 2: Enlaces de pie de página -->
      <nav aria-label="Enlaces de pie de página">
        <ul class="flex justify-content-center mt-2 md:-mt-3 gap-6 list-none p-0 m-0">
          <li>
            <a routerLink="/contacto" class="text-primary hover:text-indigo-500">
              Contacto
            </a>
          </li>
          <li>
            <a routerLink="/terminos" class="text-primary hover:text-indigo-500">
              Términos
            </a>
          </li>
          <li>
            <a routerLink="/faq" class="text-primary hover:text-indigo-500">
              FAQ
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </footer>
</div>
